// extracted by mini-css-extract-plugin
export var timelineContainer = "mobileTimeline-module--timelineContainer--iAlUl";
export var timeline0 = "mobileTimeline-module--timeline0--LQxnA";
export var timeline1 = "mobileTimeline-module--timeline1--rAloZ";
export var textContainer = "mobileTimeline-module--textContainer--1lV-V";